import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-no-sarlaft',
  standalone: false,
  templateUrl: './no-sarlaft.component.html',
  styleUrl: './no-sarlaft.component.scss'
})

export class NoSarlaftComponent {
  sessionId: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {

  }

  getLocalStorage(): number {
    return Number(localStorage.getItem('session_id'))
  }

  ngOnInit(): void {
    this.sessionId = this.getLocalStorage().toString();
  }

  volverInicio(): void {
    //this.router.navigate(['./']);
    window.location.href = "https://www.sura.co/";
  }
}
